import { render, staticRenderFns } from "./AppointmentGrid.vue?vue&type=template&id=ba4b4eb6&"
import script from "./AppointmentGrid.vue?vue&type=script&lang=js&"
export * from "./AppointmentGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports